import _sfc_main from "./ChatEditorPC.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: ["chat-editor", { disable: _setup.isMessageDisabled }] }, [_c(_setup.emoji, { staticClass: "chat-emoji", on: { "choose-emoji": _setup.handleChooseEmoji } }), _c("textarea", { directives: [{ name: "model", rawName: "v-model", value: _setup.sendMsg, expression: "sendMsg" }], ref: "editorInputEle", staticClass: "content-bottom-input", attrs: { "disabled": _setup.isMessageDisabled, "placeholder": _setup.isMessageDisabled ? _setup.t("Muted by the moderator") : _setup.t("Type a message") }, domProps: { "value": _setup.sendMsg }, on: { "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
    return _setup.sendMessage.apply(null, arguments);
  }, "input": function($event) {
    if ($event.target.composing) return;
    _setup.sendMsg = $event.target.value;
  } } })], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "be1f9416"
);
const ChatEditorPC = __component__.exports;
export {
  ChatEditorPC as default
};
